// TYPO3 EXT:form validator error codes, surfaced into a field group's data-msg (see the
// ErrorMessage Fluid partial) and consumed by the client-side validators.
export const ERROR_CODE_COUNT = '1475002994'
export const ERROR_CODE_EMAIL = '1221559976'
export const ERROR_CODE_EMPTY = '1221560910'
export const ERROR_CODE_INTEGER = '1221560718'
